import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService} from './auth.service';


type listtType = Array<{id: string, title: string, itemCount: number}>;
type projectType = Array<{id: string, title: string, itemCount: number}>;
type contactType = Array<{id: string, name: string, surname: string, nick: string}>;
type postType = Array<{id: string, title: string}>;
type noteType = Array<{id: string, title: string}>;
type routineType = Array<{id: string, title: string}>;


@Injectable()
export class DeletedService {
  isLoaded: boolean = false;
  isActual: boolean = false;
  lists: listtType = [];
  projects: projectType = [];
  contacts: contactType = [];
  posts: postType = [];
  notes: noteType = [];
  routines: routineType = [];

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  constructor(private http: HttpClient, private authService: AuthService) { 
    
  }

  getDatas(){
    let params = {
      "idUser": localStorage.getItem("idUser"),
    }
    this.http.post(this.authService.databaseURL+'getdata.php?table=deletedlists', params, this.httpOptions).subscribe(
      (data:any) => {
        this.lists = data;
        this.isActual = true;
        this.isLoaded = true;
      },
      error => this.isActual = false
    )
    
    this.http.post(this.authService.databaseURL+'getdata.php?table=deletedprojects', params, this.httpOptions).subscribe(
      (data:any) => {
        this.projects = data;
      },
      error => this.isActual = false
    )
    this.http.post(this.authService.databaseURL+'getdata.php?table=deletednotes', params, this.httpOptions).subscribe(
      (data:any) => {
        this.notes = data;
      },
      error => this.isActual = false
    )
    this.http.post(this.authService.databaseURL+'getdata.php?table=deletedcontacts', params, this.httpOptions).subscribe(
      (data:any) => {
        this.contacts = data;
      },
      error => this.isActual = false
    )
    this.http.post(this.authService.databaseURL+'getdata.php?table=deletedposts', params, this.httpOptions).subscribe(
      (data:any) => {
        this.posts = data;
      },
      error => this.isActual = false
    )
    this.http.post(this.authService.databaseURL+'getdata.php?table=deletedroutines', params, this.httpOptions).subscribe(
      (data:any) => {
        this.routines = data;
      },
      error => this.isActual = false
    )
    
  }

  deleteAll(table){
    let params = {
      "idUser": localStorage.getItem("idUser"),
    }

    this.http.post(this.authService.databaseURL+'deletedata.php?table='+table, params, this.httpOptions).subscribe(
      (data:any[]) => {
        if(table == "listall"){
          this.lists = [];
        }
        else if(table == "projectall"){
          this.projects = [];
        }
        else if(table == "contactall"){
          this.contacts = [];
        }
        else if(table == "postall"){
          this.posts = [];
        }
        else if(table == "routineall"){
          this.routines = [];
        }
        else if(table == "noteall"){
          this.notes = [];
        }
      },  
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );

  }

  delete(table,id,i){
    let params = {
      "idUser": localStorage.getItem("idUser"),
      "id": id
    }
    this.http.post(this.authService.databaseURL+'deletedata.php?table='+table, params, this.httpOptions).subscribe(
      (data:any[]) => {
        if(table == "list"){
          this.lists.splice(i,1);
        }
        else if(table == "project"){
          this.projects.splice(i,1);
        }
        else if(table == "contact"){
          this.contacts.splice(i,1);
        }
        else if(table == "post"){
          this.posts.splice(i,1);
        }
        else if(table == "routine"){
          this.routines.splice(i,1);
        }
        else if(table == "note"){
          this.notes.splice(i,1);
        }
      },  
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );
    
    
  }

  restore(table,id,i){
    let params = {
      "idUser": localStorage.getItem("idUser"),
      "id": id
    }
    this.http.post(this.authService.databaseURL+'updatedata.php?table='+table, params, this.httpOptions).subscribe(
      (data:any[]) => {
        if(table == "restorelist"){
          this.lists.splice(i,1);
        }
        else if(table == "restoreproject"){
          this.projects.splice(i,1);
        }
        else if(table == "restorecontact"){
          this.contacts.splice(i,1);
        }
        else if(table == "restorepost"){
          this.posts.splice(i,1);
        }
        else if(table == "restoreroutine"){
          this.routines.splice(i,1);
        }
        else if(table == "restorenote"){
          this.notes.splice(i,1);
        }
      },  
      error => {
        this.authService.notify = "Změny nebyly uloženy. Zkontrolujte prosím Vaše internetové připojení.";
        this.isActual = false;
      }
    );

  }


}



// WEBPACK FOOTER //
// ./src/app/services/deleted.service.ts